var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 7.99967L7.33331 9.33301L10.3333 6.33301M4.88916 2.54547C5.42505 2.50271 5.93379 2.29198 6.34296 1.94329C7.2978 1.12958 8.70216 1.12958 9.657 1.94329C10.0662 2.29198 10.5749 2.50271 11.1108 2.54547C12.3614 2.64527 13.3544 3.6383 13.4542 4.88885C13.4969 5.42474 13.7077 5.93348 14.0564 6.34265C14.8701 7.29749 14.8701 8.70186 14.0564 9.6567C13.7077 10.0659 13.4969 10.5746 13.4542 11.1105C13.3544 12.361 12.3614 13.3541 11.1108 13.4539C10.5749 13.4966 10.0662 13.7074 9.657 14.0561C8.70216 14.8698 7.2978 14.8698 6.34296 14.0561C5.93379 13.7074 5.42505 13.4966 4.88916 13.4539C3.63861 13.3541 2.64557 12.361 2.54578 11.1105C2.50301 10.5746 2.29228 10.0659 1.94359 9.6567C1.12989 8.70186 1.12989 7.29749 1.94359 6.34265C2.29228 5.93348 2.50301 5.42474 2.54578 4.88885C2.64557 3.6383 3.63861 2.64527 4.88916 2.54547Z",
    stroke: "#37A372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.70006d3fcb78fa15e0c4afd17d36a5a1.svg";
export { ForwardRef as ReactComponent };